import React, { useContext } from "react";

import { Media } from "../../../components/Media/Media";
import { Headline } from "../../../components/Headline";

import * as styles from "./mediaSlideContent.module.less";
import GeneralPageContext from "../../../templates/GeneralPageContext";
import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

export function MediaSlideContent({
    mediaElement,
    thumbnailsOnly = false,
    active = false,
    activeClass,
    layoutReduced,
}) {
    const {
        layout: { showAnchorNavigation }
    } = useContext(GeneralPageContext);

    const description =
        mediaElement?.mediaDescription || mediaElement?.media?.alt;

    return (
        <div
            className={gcs(
                styles.mediaSlideContainer,
                [thumbnailsOnly, styles.thumbnail],
                [layoutReduced, styles.layoutReduced],
                [showAnchorNavigation, styles.anchored],
                [active, activeClass]
            )}
        >
            <Media
                className={styles.mediaSlideMedia}
                videoControls={true}
                mediaElement={mediaElement}
                thumbnailsOnly={thumbnailsOnly}
                gridDisable={true}
                // showDescription={false}
            />

            {/* {!thumbnailsOnly && (
                <span className={styles.mediaDescription}>
                    {!mediaElement.hideImageDescription && description}
                </span>
            )} */}
        </div>
    );
}
